customElements.get("ajax-modal") || customElements.define("ajax-modal", class extends HTMLElement {
  button=this.querySelector("a");
  url=this.button?.href;
  view=this.dataset.view;
  parent=this.closest("li") || this.closest(".shopify-section");
  delay=0;
  constructor() {
    super();
  }
  loadStart() {
    this.parent?.classList.add("opacity-50", "cursor-wait");
  }
  loadEnd() {
    this.parent?.classList.remove("opacity-50", "cursor-wait");
  }
  load(t) {
    this.loadStart();
    const e = new URL(this.url);
    this.view && e.searchParams.set("view", this.view), fetch(e).then(t => {
      if (t.ok) return t.text();
      console.warn(t), location.href = e;
    }).then(e => {
      document.body.insertAdjacentHTML("beforeend", e), window.dispatchEvent(new CustomEvent("locker_add", {
        detail: this.modalId
      })), setTimeout(() => {
        t && t.click(), document.getElementById(this.modalId)?.click();
      }, this.hasAttribute("data-index") ? this.delay : 0);
    }).catch(t => {
      console.warn(t), location.href = e;
    }).finally(() => {
      this.loadEnd();
    });
  }
  connectedCallback() {
    this.url && (this.modalId = this.url.split("/"), this.modalId = `Modal-${this.modalId[this.modalId.length - 1].split("?")[0]}`, 
    this.view && (this.modalId += `-${this.view}`), this.button.addEventListener("click", t => {
      t.preventDefault();
      const e = document.querySelector("[data-locker]:checked");
      if (document.getElementById(this.modalId)) if (e && e.click(), this.hasAttribute("data-index")) {
        const t = document.querySelector(`#${this.modalId} ~ div vanilla-slider`);
        t && t.dispatchEvent(new CustomEvent("goto", {
          bubbles: !1,
          detail: {
            index: Number.parseInt(this.dataset.index)
          }
        })), setTimeout(() => document.getElementById(this.modalId).click(), this.delay);
      } else document.getElementById(this.modalId).click(); else this.hasAttribute("data-index") && (window.index = Number.parseInt(this.dataset.index)), 
      this.load(e);
    }));
  }
});